import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import { Provider } from 'react-redux'

import store from './App/store'
import GetRoutes from './App/routes'

import './styles/index.scss'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'antd/dist/antd.css'

import { initGA } from './Analytics/googleAnalytics'
import { initFacebookPixel } from './Analytics/facebook'

initGA()
initFacebookPixel()

ReactDOM.render(
  <Provider store={store}>
    <Router basename='/account'>
      <GetRoutes store={store} />
    </Router>
  </Provider>,
  document.getElementById('root'),
)

// ReactDOM.render(<App />, document.getElementById('root'))
